module.exports = __webpack_public_path__ + "static/cookies-009603ee86b12a953530dd93b4be4cdf.svg";